import './App.css';
import {
  Route,
  BrowserRouter as Router,
  Routes,
} from 'react-router-dom';
import MainContainer from './Components/MainContainer/MainContainer';
import PrivacyPolicyContainer from './Components/PrivacyPolicy/PrivacyPolicyContainer';
import TermsAndConditionsContainer from './Components/TermsAndConditions/TermsAndConditionContainer';

function App() {
  return (
     <Router basename={process.env.REACT_APP_BASENAME}>
      <div className="App">
        <Routes>
          <Route path='/' element={<MainContainer/>}/>
          <Route path='/privacy-policy' element={<PrivacyPolicyContainer/>}/>
          <Route path='/terms-and-conditions' element={<TermsAndConditionsContainer/>}/>
        </Routes>
      </div>
    </Router>
  );
}

export default App;